_collow.components.ProfileSettings = class ProfileSettings extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  amountOfFeatures;
  phoneInput;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    if (elements.infoForm?.firstname) this.getUserInfo();
    if (elements.infoForm?.["kvk_number"]) this.getCompanyInfo();

    this.listen(elements.infoForm, "change", this.enableInfoSubmit);
    this.listen(elements.infoForm, "change", this.validateSelectValue);
    this.listen(elements.infoForm, "submit", this.saveInfo);

    this.listen(elements.passwordForm, "change", this.enablePasswordSubmit);
    this.listen(elements.passwordForm, "submit", this.savePassword);

    if (elements.infoForm?.number)
      this.phoneInput = window.intlTelInput(elements.phone, {
        preferredCountries: ["nl", "be"],
        autoInsertDialCode: true,
        initialCountry: "nl",
        nationalMode: false,
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
      });
    if (elements?.birthdate) this.setMaxDate();
  }
  /**s
   * set inital user data
   */
  getUserInfo = () => {
    fetching(`${this.params.path}/user/personal`, "get")
      .then((result) => {
        Object.entries(result).forEach(([key, value]) => {
          if (this.elements.infoForm?.[key])
            this.elements.infoForm[key].value = value;
        });

        this.listen(this.elements.infoForm, "change", () =>
          this.listen(this.elements.saveInfo, "click", this.saveUserInfo)
        );
      })
      .catch((err) =>
        this.dispatch(this.elements.infoForm, "_collow-custom-error", err)
      );
  };

  setMaxDate = () => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    this.elements.birthdate.max = formattedDate;
  };

  enableInfoSubmit = () => {
    const form = this.elements.infoForm;
    if (
      (form?.["company_name"]?.value &&
        form?.["kvk_number"]?.value &&
        form?.email.value &&
        form?.["number"]?.value) ||
      (form?.firstname?.value && form?.lastname?.value)
    ) {
      this.elements.saveInfo.removeAttribute("disabled");
      this.elements.saveInfo.dataset.settingsChanges = true;
    }
  };

  enablePasswordSubmit = () => {
    const form = this.elements.passwordForm;

    if (form.password && form["new_password"] && form["new_password-2"]) {
      this.elements.savePassword.removeAttribute("disabled");
      this.elements.savePassword.dataset.settingsChanges = true;
    }
  };

  getCompanyInfo = () =>
    fetching(`${this.params.path}/company/me`, "get").then((res) => {
      const form = this.elements.infoForm;
      form["company_name"].value = res?.["company_name"];
      form["kvk_number"].value = res?.["kvk_number"];
      form.email.value = res?.email;
      this.phoneInput.setNumber(res?.["phone_number"]);
      // TODO fix number of employees
      // form["number_employees"] = res?.["number_employees"];
    });

  /**
   * get user info from fields and make api call to update
   */
  saveInfo = (e) => {
    e.preventDefault();
    const formData = new FormData(this.elements.infoForm);

    if (this.phoneInput) {
      const number = this.phoneInput.getNumber();
      formData.append("phone_number", number);
    }
    fetching(
      this.params.path +
      (this.elements.infoForm["kvk_number"]
        ? "/company/me"
        : "/user/personal"),
      "put",
      formData
    )
      .then((res) => {
        const localStorageJson = localStorage.getProgressJson();
        const newJson = { ...localStorageJson, ...res };
        localStorage.setItem("progressJson", JSON.stringify(newJson));
        this.resetButton(this.elements.saveInfo);
        _collow.Notify.success(this.params.changesSaved);
      })
      .catch((err) => {
        console.error(err);
        _collow.Notify.error(err);
      });

    this.listen(this.elements.infoForm, "change", () =>
      this.elements.infoChangeSucces.setAttribute("hidden", "")
    );
  };

  //Function used when changing passwords
  savePassword = (e) => {
    e.preventDefault();
    //Is the password the same as the confirm password?
    if (this.elements.passwordForm[1].value !== this.elements.passwordForm[2].value) {
      _collow.Notify.error(this.params.messagePasswordNoMatch, {});
      return;
      // Does the password have min 8 characters, 1 upper character and 1 number?
    } else if (!(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(this.elements.passwordForm[1].value))) {
      _collow.Notify.error(this.params.messagePasswordNoRequirements, {});
      return;
    }
    const formData = new FormData(this.elements.passwordForm);
    fetching(`${this.params.path}/user/password`, "put", formData)
      .then(() => {
        this.resetButton(this.elements.savePassword);
        _collow.Notify.success(this.params.passwordChanged)
      })
      .catch((err) => {
        console.log(typeof err);
        console.log(err);
        console.log(this.params);
        (err == 401) ? _collow.Notify.error(this.params.messagePasswordWrong, {}) : _collow.Notify.error(err)
      });

    this.listen(this.elements.passwordForm, "change", () =>
      this.elements.pwChangeSucces.setAttribute("hidden", "")
    );
  };

  resetButton = (button) => {
    button.setAttribute("disabled", "");
    button.dataset.settingsChanges = false;
  };

  followingState = ({ allow_following, following_checkbox_active }) => {
    if (following_checkbox_active) {
      this.elements.matchingCheck.closest(
        "[data-matching]"
      ).dataset.matching = true;
      this.elements.matchingCheck.disabled = false;
    }
    if (allow_following) this.elements.matchingCheck.checked = true;
    this.listen(
      this.elements.matchingCheck,
      "click",
      this.changeFollowingState
    );
  };

  changeFollowingState = async ({ target }) => {
    const state = target.checked;
    target.disabled = true;
    const fd = new FormData();
    fd.append("allow_following", state);
    fetch(this.params.path + "/user/personal", {
      method: "put",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: fd,
    })
      .then((resp) => {
        target.disabled = false;
        if (!resp.ok) {
          target.checked = !state;
          throw "failed to check";
        }
        const progressJson = localStorage.getProgressJson();
        progressJson["allow_following"] = state;
        localStorage.setItem("progressJson", JSON.stringify(progressJson));
      })
      // TODO proper error handling
      .catch((err) => console.log(err));
  };

  validateSelectValue = ({ target }) => {
    if (target == this.elements.attainment || target == this.elements.degree) {
      const selectedOption =
        target.options[target.options.selectedIndex].dataset.triggerField ==
        "true";

      // select the attainment or degree field and set or remove hidden
      this.elements[target == this.elements.attainment ? "eduInfo" : "yearUni"][
        (selectedOption ? "remove" : "set") + "Attribute"
      ]("hidden", "");
    }
  };
};
